import { render } from "./PatientAuthorizedContactsList.vue?vue&type=template&id=3310ed76&ts=true"
import script from "./PatientAuthorizedContactsList.ts?vue&type=script&lang=ts&external"
export * from "./PatientAuthorizedContactsList.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__